import React, { useState, useEffect } from 'react';
import { workTasksAPI } from '../services/api';
import './MilestoneRules.css';

function MilestoneRules() {
  const [data, setData] = useState({ milestones: [], config: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadRules();
  }, []);

  const loadRules = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await workTasksAPI.getRules();
      setData(res.data.data || { milestones: [], config: {} });
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to load tracking rules');
      setData({ milestones: [], config: null });
    } finally {
      setLoading(false);
    }
  };

  const ruleTypeLabel = (rt) => {
    const map = {
      reference: 'Reference',
      actual_only: 'Actual only',
      due_actual: 'Due + actual',
      window_due: 'Window + due',
      window: 'Window',
      due_conditional: 'Due (conditional)',
    };
    return map[rt] || rt;
  };

  if (loading) {
    return (
      <div className="milestone-rules-page">
        <div className="milestone-rules-header">
          <h1>Referral tracking rules</h1>
        </div>
        <p className="loading-msg">Loading rules...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="milestone-rules-page">
        <div className="milestone-rules-header">
          <h1>Referral tracking rules</h1>
        </div>
        <p className="error-msg">{error}</p>
      </div>
    );
  }

  const { milestones = [], config = {} } = data;

  return (
    <div className="milestone-rules-page">
      <div className="milestone-rules-header">
        <h1>Referral tracking rules</h1>
      </div>
      <p className="milestone-rules-intro">
        How each referral tracking item’s due date and window are calculated. Legal values and buffers are configurable.
      </p>

      {config && Object.keys(config).length > 0 && (
        <section className="rules-config">
          <h2>Current configuration</h2>
          <ul>
            <li>Initial IFSP: legal = open + <strong>{config.initial_ifsp_legal_days}</strong> days; buffer = <strong>{config.initial_ifsp_buffer_days}</strong> day(s)</li>
            <li>TPM/TPC window end: legal = age 3 − <strong>{config.tpm_tpc_legal_days}</strong> days; buffer = <strong>{config.tpm_tpc_buffer_days}</strong> day(s)</li>
            <li>Exit due: legal = age 3 − <strong>{config.exit_legal_days}</strong> days; buffer = <strong>{config.exit_buffer_days}</strong> day(s)</li>
            <li>School window: DOB + <strong>{config.school_window_months?.[0] ?? '—'}</strong> to <strong>{config.school_window_months?.[1] ?? '—'}</strong> months</li>
            <li>Exit rule: no exit due if Initial IFSP is within <strong>{config.exit_ifsp_within_months_of_age3}</strong> months of age 3</li>
          </ul>
        </section>
      )}

      <section className="rules-list">
        <h2>Tracking items and rules (in English)</h2>
        <div className="rules-cards">
          {milestones.map((m) => (
            <div key={m.milestone_type} className="rule-card">
              <div className="rule-card-header">
                <span className="rule-name">{m.milestone_name}</span>
                <span className="rule-type-badge">{ruleTypeLabel(m.rule_type)}</span>
              </div>
              <p className="rule-description">{m.rule_description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default MilestoneRules;
